import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Toolbar from '@material-ui/core/Toolbar';
import { makeStyles, useMediaQuery } from '@material-ui/core';

import Logo from 'common/components/header/Logo';
import DownLgNavList from 'common/components/header/DownLgNavList';
import UpLgNavList from 'common/components/header/UpLgNavList';
import CustomMuiLink from 'common/components/custom-mui-link/CustomMuiLink';
import theme from 'common/theme/theme';

const Header: React.FC<IHeaderProps> = ({ RouteLink }) => {
  const classes = useStyles();
  const isUpLg = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <AppBar
      position="static"
      color="inherit"
      style={{
        boxShadow: '0px 1.5px 3px rgba(0, 0, 0, 0.15)',
      }}
    >
      <Toolbar>
        <Container maxWidth="xl">
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box>
              <CustomMuiLink
                href="/community/"
                className={classes.custom_muilink}
              >
                <Logo />
              </CustomMuiLink>
            </Box>
            {isUpLg ? (
              <UpLgNavList RouteLink={RouteLink} />
            ) : (
              <DownLgNavList RouteLink={RouteLink} />
            )}
          </Box>
        </Container>
      </Toolbar>
    </AppBar>
  );
};

export default Header;

const useStyles = makeStyles((theme) => ({
  custom_muilink: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
